import { SlateResponse } from "../../common/store/types";
import { IApiOptions, api } from "../../utils/api/actions";
import { Constants } from "./constants";
import { StackConstraint} from "./types";

const baseUrl = process.env.REACT_APP_API_URL || '';

export const setBoostedPlayer = (player: string, boostValue: number) => ({
  type: Constants.SET_BOOST_PLAYER,
  payload: { player, boostValue},
})
export const removeBoostedPlayer = (player: string, boostValue: number) => ({
  type: Constants.REMOVE_BOOST_PLAYER,
  payload: { player, boostValue},
})
export const clearBoostedPlayer = () => ({
  type: Constants.CLEAR_BOOST_PLAYERS,
  payload: {},
})
export const setGeneratedSlate = (slate: SlateResponse) => ({
  type: Constants.SET_GENERATED_SLATE,
  payload: slate,
})
export const setExportableLineups = (lineups: string) => ({
  type: Constants.SET_EXPORTABLE_LINEUPS,
  payload: lineups,
})
export const setConstraints = (constraints: StackConstraint[]) => ({
  type: Constants.SET_CONSTRAINTS,
  payload: constraints,
})
export const setUseCustomExposures = (useCustomExposure: boolean) => ({
  type: Constants.USE_CUSTOM_EXPOSURES,
  payload: useCustomExposure,
})

export const setRunback = (runback: StackConstraint) => ({
  type: Constants.SET_RUNBACK,
  payload: runback,
})

export const setDiversity = (diversity: number | number[]) => ({
  type: Constants.SET_DIVERSITY,
  payload: diversity,
})

export const setLineupDiversity = (diversity: number | number[]) => ({
  type: Constants.SET_LINEUP_DIVERSITY,
  payload: diversity,
})
export const triggerContestGen = (slateId: string, user: string, totalLineups: number, boostedPlayers: { [key: string]: number}, stacks: StackConstraint[], runbackPercent: number, lateSwap?: boolean, useCustomProjections?: boolean, diversity?: number) => {
  const body = {
    user,
    slateId,
    totalLineups,
    boostedPlayers,
    stacks,
    runbackPercent,
    lateSwap: lateSwap,
    useCustomProjections,
    diversity,
  };

  fetch(`${baseUrl}/api/contestGenerator/lambdaContestGenerator`, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Accept-encoding': 'gzip, deflate',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body),
  });

  return {
    type: Constants.SET_LOADING,
    payload: true,
  }
}

export const stopLoading = () => ({
  type: Constants.SET_LOADING,
  payload: false,
})

export const startLoading = () => ({
  type: Constants.SET_LOADING,
  payload: true,
})

export const setPoolSize = (size: number) => ({
  type: Constants.SET_POOL_SIZE,
  payload: size,
})

export const setPercentToFirst = (percent: number) => ({
  type: Constants.SET_PERCENT_TO_FIRST,
  payload: percent,
})

export const setLiveContestId = (contestId: string) => ({
  type: Constants.SET_LIVE_CONTEST_ID,
  payload: contestId,
})

export const getContestPlayers = (slateId: string, user: string, liveContestId?: string, totalEntries?: number) => {
  let options: IApiOptions = {
    method: 'GET',
    route: '',
  };

  const route = '/api/contestGenerator/getContestPlayers';

  options = {
    ...options,
    route,
    params: {
      slateId,
      user,
      liveContestId,
      totalEntries,
    }
  };

  return api(
    Constants.SET_CONTEST_PLAYERS, {
    ...options,
  });
};

export const getContestGenLineups = (slateId: string, user: string, liveContestId?: string, totalEntries?: number) => {
  let options: IApiOptions = {
    method: 'GET',
    route: '',
  };

  const route = '/api/contestGenerator/getContestLineups';

  options = {
    ...options,
    route,
    params: {
      slateId,
      user,
    }
  };

  return api(
    Constants.SET_CONTEST_GEN_LINEUPS, {
    ...options,
  });
};

export const getContestLineups = (slateId: string, user: string) => {
  let options: IApiOptions = {
    method: 'GET',
    route: '',
  };

  const route = '/api/contests/getLateSwapRoiByLineup';

  options = {
    ...options,
    route,
    params: {
      slateId,
      user,
    }
  };

  return api(
    Constants.SET_CONTEST_LINEUPS, {
    ...options,
  });
};

export const getContestStacks = (slateId: string, user: string) => {
  let options: IApiOptions = {
    method: 'GET',
    route: '',
  };

  const route = '/api/contestGenerator/getContestStacks';

  options = {
    ...options,
    route,
    params: {
      slateId,
      user,
    }
  };

  return api(
    Constants.SET_CONTEST_STACKS, {
    ...options,
  });
};